import { useContext } from 'react'
import SnackbarCtx from 'app/contexts/snackbar/SnackbarCtx'

export default function useSnackbar () {
  const { openSnackbar, closeSnackbar } = useContext(SnackbarCtx)
  return { openSnackbar, closeSnackbar }
}
